import ApiClient from './ApiClient';

export default new ApiClient('conversation_pins', { accountScoped: true });
